<template>
  <div>
  <div class="flexLayoutShop">
    <div class="leftSidebar">
      <div class="logoContainer">
        <a href="#"><img src="../../assets/images/logo-white.svg" alt="" /></a>
      </div>
    </div>
    <div class="flexLayoutBody">
      <!-- <h2> Terms of Use</h2> -->
<div name="termly-embed" data-id="59a77428-830d-42f9-b138-bca2544b5bda" data-type="iframe"></div>

    </div>
  </div>
  </div>

</template>
<script type="text/javascript">(function(d, s, id) {
  var js, tjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = d.createElement(s); js.id = id;
  js.src = "https://app.termly.io/embed-policy.min.js";
  tjs.parentNode.insertBefore(js, tjs);
}(document, 'script', 'termly-jssdk'));</script>
